import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPhotoUrl, priceToCurrency } from "utils/common";
import Actions from "./components/Actions";
import ComboDetailModal from "./components/DetailModal";
import * as comboActions from "./slice";

function Combo() {
  const dispatch = useDispatch();
  const { combos, pagination, isLoading, isProcessing, isCompleted } =
    useSelector((state) => state.expressCombo);

  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectingCombo, setSelectingCombo] = useState(null);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(comboActions.fetchCombos(pagination));
  }, []);

  useEffect(() => {
    if (isCompleted) {
      setOpenDetailModal(false);
      setSelectingCombo(null);
    }
  }, [isCompleted]);

  const onOpenDetailModal = (combo = null) => {
    setSelectingCombo(combo);
    setOpenDetailModal(true);
  };

  const onDelete = (combo) => {
    Modal.confirm({
      title: `Xác nhận xoá gói tiết kiệm`,
      content: `Bạn có chắc chắn muốn xoá gói tiết kiệm này?`,
      onOk: () => dispatch(comboActions.deleteCombo(combo._id)),
      centered: true,
    });
  };

  const onSubmit = (combo, formData) => {
    if (combo._id) {
      dispatch(comboActions.updateCombo(combo, formData));
    } else {
      dispatch(comboActions.createCombo(formData));
    }
  };

  const onCancel = () => {
    setOpenDetailModal(false);
    setSelectingCombo(null);
    dispatch(comboActions.setIsProcessing(false));
  };

  const onChangeNameSearch = (e) => {
    setSearchName(e.target.value);
  };

  const onSearch = () => {
    dispatch(
      comboActions.fetchCombos({
        ...pagination,
        name: searchName,
      })
    );
  };

  const onTableChange = async (pagination) => {
    dispatch(
      comboActions.fetchCombos({
        ...pagination,
        name: searchName,
      })
    );
  };
  const columns = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      render: (text, record, index) => (
        <Typography.Paragraph
          copyable={{
            text: record._id,
            tooltips: ["Sao chép ID", "Đã sao chép!"],
          }}
        >
          {(pagination.current - 1) * pagination.pageSize + index + 1}
        </Typography.Paragraph>
      ),
    },
    {
      title: "Ảnh thumb",
      dataIndex: "thumb",
      width: "10%",
      render: (image) =>
        image ? (
          <Image
            alt="BST"
            src={getPhotoUrl(image?.path || null)}
            width={100}
            height={100}
          />
        ) : null,
    },
    {
      title: "Ảnh cover",
      dataIndex: "cover",
      width: "280px",
      render: (image) =>
        image ? (
          <Image
            alt="BST"
            src={getPhotoUrl(image?.path || null)}
            width={250}
            height={100}
          />
        ) : null,
    },
    {
      title: "Tên gói tiết kiệm",
      render: (record) => (
        <>
          <Typography.Paragraph strong>{record.name}</Typography.Paragraph>
          <Typography.Paragraph>
            <Tag color="blue">x{record.quantity}</Tag>
            {record.voucher.name} ({record.voucher.code})
          </Typography.Paragraph>
        </>
      ),
    },
    {
      title: "Giá",
      dataIndex: "price",
      align: "center",
      width: "10%",
      render: (price) => priceToCurrency(price),
    },
    {
      title: "Ưu tiên",
      dataIndex: "priority",
      align: "center",
      width: "10%",
      sorter: (a, b) => a.priority - b.priority,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      align: "center",
      width: 150,
      render: (active) =>
        active ? (
          <Tag color="#4caf50">Active</Tag>
        ) : (
          <Tag color="#f44336">In-active</Tag>
        ),
    },
    {
      title: "Thao tác",
      align: "center",
      width: "15%",
      render: (record) => (
        <Actions
          record={record}
          onEdit={onOpenDetailModal}
          onDelete={onDelete}
        />
      ),
    },
  ];
  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={2}>
          [{pagination?.total || "0"}] Gói tiết kiệm
        </Typography.Title>
        <Space size="middle">
          <Input.Search
            placeholder="Tìm theo tên"
            onChange={onChangeNameSearch}
            onSearch={onSearch}
            enterButton
            allowClear
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onOpenDetailModal()}
          >
            Thêm mới
          </Button>
        </Space>
      </Row>
      <Divider />
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={combos}
        rowKey={(record) => record._id}
        pagination={pagination}
        onChange={onTableChange}
      />
      {openDetailModal && (
        <ComboDetailModal
          open={openDetailModal}
          isProcessing={isProcessing}
          onSubmit={onSubmit}
          onCancel={onCancel}
          combo={selectingCombo}
        />
      )}
    </>
  );
}

export default Combo;
